import { createIconComponent } from '../../factory/create-icon-component';
export const LocationPinIcon = createIconComponent(
  'LocationPinIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.99991 10.4997C2.99991 5.49969 6.99991 1.99969 11.9999 1.99969C16.9999 1.99969 20.9999 5.49969 20.9999 10.4997C20.9999 18.3515 13.9999 21.9995 11.9999 21.9995C9.99991 21.9995 2.99991 18.3515 2.99991 10.4997Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle
      cx="11.9999"
      cy="10.9997"
      r="3"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>,
);
